module.exports = __webpack_public_path__ + "static/media/logo_blue.d7780b6d.svg";